import styled, { css } from 'styled-components';

export const TempHumiBoxContainer = styled.div`
  width: 92vw;
  height: 20vh;
  margin-left: 3rem;
  overflow-y: auto;

  & > table {
    width: 100%;
    border-collapse: collapse;
  }

  & > table,
  tr,
  th,
  td {
    border: 1px solid #000;
  }

  & > table > thead > tr > th {
    font-size: 1.1rem;
    background-color: #ececec;
    color: black;
    height: 8vh;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  & > table > tbody > tr {
    background-color: white;
    color: black;
    height: 5.5vh;
    
    &.stale-data {
      background-color: #f0f0f0;
      color: #999;
    }
  }

  & > table > tbody > tr > td {
    font-size: 1.2rem;
    padding: 8px;
    text-align: center;

    &.danger {
      background-color: #ffcccc;
      color: #d8000c;
      font-weight: bold;
    }
  }
`;

export const ArrangementStatusContainer = styled.div`
  position: absolute;
  left: 1200px;
  top: 31px;
  background: ${(props) => props.theme.legendBg};
  width: 315px;
  color: #000;

  & > div.statusBox {
    display: flex;
    flex-direction: row;
    text-align: center;

    & > div.title {
      border-right: 1px solid #000;
      padding: 0 5px;
    }
    & > div.content {
      padding: 0 5px;
    }
  }

  & > table,
  tr,
  th,
  td {
    border: 1px solid #000;
  }

  & > table {
    width: 100%;

    & > thead > tr > th {
      font-size: 12px;
    }
    & > tbody > tr > td {
      font-size: 14px;

      & > img {
        width: 40px;
      }
    }
  }
`;

